export interface HistorialMedico {
  exists: boolean;

  tipoSangre: string | null;

  contactoPrincipalNombre: string;
  contactoPrincipalParentesco: string;
  contactoPrincipalTelCelular: string;
  contactoPrincipalTelTrabajo: string | null;

  contactoSecundarioNombre: string | null;
  contactoSecundarioParentesco: string | null;
  contactoSecundarioTelCelular: string | null;
  contactoSecundarioTelTrabajo: string | null;

  alergiaMedicamentos: string | null;
  alergiaAlimentos: string | null;
  alergiaAmbiental: string | null;
  sinAlergiasConocidas: boolean;

  usaLentes: boolean;
  usaAparatoAuditivo: boolean;
  usaOrtopedico: boolean;
  otroApoyo: string | null;

  asma: boolean;
  convulsiones: boolean;
  diabetesInfantil: boolean;
  problemasCardiacos: boolean;
  otroPadecimiento: string | null;

  tomaMedicamentoRegular: boolean;
  nombreMedicamento: string | null;
  dosisHorario: string | null;
  requiereAdministracionEscolar: boolean;

  tieneRestriccionEF: boolean;
  motivoRestriccionEF: string | null;
  restriccionesAlimentarias: string | null;

  notasAdicionales: string | null;
}

export const emptyHistorialMedico: HistorialMedico = {
  exists: false,
  tipoSangre: null,
  contactoPrincipalNombre: '',
  contactoPrincipalParentesco: '',
  contactoPrincipalTelCelular: '',
  contactoPrincipalTelTrabajo: null,
  contactoSecundarioNombre: null,
  contactoSecundarioParentesco: null,
  contactoSecundarioTelCelular: null,
  contactoSecundarioTelTrabajo: null,
  alergiaMedicamentos: null,
  alergiaAlimentos: null,
  alergiaAmbiental: null,
  sinAlergiasConocidas: false,
  usaLentes: false,
  usaAparatoAuditivo: false,
  usaOrtopedico: false,
  otroApoyo: null,
  asma: false,
  convulsiones: false,
  diabetesInfantil: false,
  problemasCardiacos: false,
  otroPadecimiento: null,
  tomaMedicamentoRegular: false,
  nombreMedicamento: null,
  dosisHorario: null,
  requiereAdministracionEscolar: false,
  tieneRestriccionEF: false,
  motivoRestriccionEF: null,
  restriccionesAlimentarias: null,
  notasAdicionales: null,
};

export interface HistorialMedicoState {
  studentId: string | null;
  record: HistorialMedico;
  loading: boolean;
  saving: boolean;
  saveSuccess: boolean;
  error: string | null;
}

export const initialHistorialMedicoState: HistorialMedicoState = {
  studentId: null,
  record: emptyHistorialMedico,
  loading: false,
  saving: false,
  saveSuccess: false,
  error: null,
};
